import { downloadInvoices, sendInvoices, exportedInvoiceByRequest } from "../../api/services/invoiceService";
import { InvoiceExportDetailGrouping, InvoiceExportDetail } from "../../api/models/invoiceExportDetail";
import { useAsync } from "react-async";
import { useHistory, useLocation } from "react-router-dom";
import fileDownload from "js-file-download";
import InvoiceExportRequest, { InvoiceExportRequestDistrict } from "../../api/requests/invoiceExportRequest";
import Layout from "../../components/layout";
import moment from "moment";
import StringResponse from "../../api/responses/stringResponse";
import { useEffect, useState } from 'react';
import { useAppSelector } from "../../app/hooks";
import { Role } from '../../common/constants';
import QuickBooksDateModal from '../../components/quickBooksDateModal';
import { hasRole } from "../../common/utils";

type ViewState = {
    exportedInvoices: InvoiceExportDetailGrouping;
};

const InvoiceExportsDetail = () => {
    const history = useHistory();
    const { state } = useLocation<ViewState>();
    const [isLoading, setIsLoading] = useState(false);
    const [exportedGroup, setExportedGroup] = useState<InvoiceExportDetail[]>();
    const userRoles = useAppSelector((s) => s.user.roles);
    const isAccounting = hasRole(userRoles!, Role.Accounting)
    const isSuperUser = hasRole(userRoles!, Role.SuperUser)
    const [showDateModal, setShowDateModal] = useState(false);

    const navigateToDetailReport = (districtId: number, year: number, month: number, programId: number | null = null) => {
        history.push(`/accounting/invoice/detail?districtId=${districtId}&year=${year}&month=${month}${programId ? `&programId=${programId}` : ``}`);
    }

    const navigateToSummaryReport = (districtId: number, year: number, month: number, programId: number | null = null) => {
        history.push(`/accounting/invoice/summary?districtId=${districtId}&year=${year}&month=${month}${programId ? `&programId=${programId}` : ``}`);
    }

    useEffect(() => {
        handleInvoiceDetailsData();
    }, []);

    const invoiceDetailsData = async () => {
        setIsLoading(true);
        const firstInvoice = state.exportedInvoices?.exportGroup[0];
        const [year, month] = [firstInvoice.year, firstInvoice.month];
        const invoiceDistrictIdsToExport = state.exportedInvoices?.exportGroup?.map((d, i) => d.districtId) ?? [];
        const invoiceDistrictsToExport: InvoiceExportRequestDistrict[] = [];

        state.exportedInvoices?.exportGroup?.map((d, i) => {
            invoiceDistrictsToExport.push({
                districtId: d.districtId,
                programId: d.programId,
            });
        })

        const invoiceDownloadRequest: InvoiceExportRequest = {
            year: year,
            month: month,
            districtIds: invoiceDistrictIdsToExport,
            districts: invoiceDistrictsToExport
        };
        downloadInvoiceCsvAsync.run(invoiceDownloadRequest);

        await exportedInvoiceByRequest(invoiceDownloadRequest).then(response => {
            const data = response.data.exportedInvoicesByDate[0].exportGroup;
            setExportedGroup(data);
        }).finally(() => {
            setIsLoading(false);
        });
    };

    const handleInvoiceDetailsData = () => {
        invoiceDetailsData();
    };

    const doSendInvoice = async (quickBooksDate?: Date) => {
        setIsLoading(true);
        const firstInvoice = state.exportedInvoices?.exportGroup[0];
        const [year, month] = [firstInvoice.year, firstInvoice.month];
        const invoiceDistrictIdsToExport = state.exportedInvoices?.exportGroup?.map((d, i) => d.districtId) ?? [];
        const invoiceDistrictsToExport: InvoiceExportRequestDistrict[] = [];

        state.exportedInvoices?.exportGroup?.map((d, i) => {
            invoiceDistrictsToExport.push({
                districtId: d.districtId,
                programId: d.programId,
            });
        })

        const invoiceDownloadRequest: InvoiceExportRequest = {
            year: year,
            month: month,
            districtIds: invoiceDistrictIdsToExport,
            districts: invoiceDistrictsToExport,
            transactionDate: quickBooksDate != undefined ? quickBooksDate : undefined
        };

        await sendInvoices(invoiceDownloadRequest).finally(() => {
            setIsLoading(false);
        });
    }

    const handleSendInvoice = () => {
        var allStatusesClear = true;
        exportedGroup?.map((eg, idx) => {
            allStatusesClear = allStatusesClear && (eg.status === "");
        });
        if (allStatusesClear) {
            setShowDateModal(true);
        } else {
            doSendInvoice();
        }
    };

    const downloadInvoiceCsv = () => {
        const firstInvoice = state.exportedInvoices?.exportGroup[0];
        const [year, month] = [firstInvoice.year, firstInvoice.month];
        const invoiceDistrictIdsToExport = state.exportedInvoices?.exportGroup?.map((d, i) => d.districtId) ?? [];
        const invoiceDistrictsToExport: InvoiceExportRequestDistrict[] = [];

        state.exportedInvoices?.exportGroup?.map((d, i) => {
            invoiceDistrictsToExport.push({
                districtId: d.districtId,
                programId: d.programId,
            });
        })

        const invoiceDownloadRequest: InvoiceExportRequest = {
            year: year,
            month: month,
            districtIds: invoiceDistrictIdsToExport,
            districts: invoiceDistrictsToExport
        };

        downloadInvoiceCsvAsync.run(invoiceDownloadRequest);
    }

    const downloadInvoiceCsvAsync = useAsync({
        deferFn: (args: any[]) => downloadInvoices(args[0]),
        onResolve: (response: StringResponse) => {
            const now = moment(new Date()).format('yyyy-MM-DD_THHmm');
            fileDownload(response.data, `PTS_QuickBooks_Invoices_${now}.iif`);
        },
        onReject: (error: Error) => {
            window.alert(error);
        },
    });

    const handleQuickBooksDateSelected = (
        transactionDate?: Date
    ) => {
        doSendInvoice(transactionDate);
        /*const invoiceDistrictIdsToExport = districts
            ?.filter(d => d.isMarkedForExport)
            .map((d, i) => d.districtId) ?? [];

        const invoiceExportRequest: InvoiceExportRequest = {
            year: year,
            month: month,
            districtIds: invoiceDistrictIdsToExport,
            undoExport: false,
            transactionDate: moment(transactionDate?.toDateString()).toDate()
        };*/
        setShowDateModal(false);
        /*onInvoiceExport(invoiceExportRequest);*/
    }
    return (
        <Layout isLoading={isLoading}>
            <div className='mt-1 rounded-lg bg-white shadow px-4 py-3'>
                {/* QuickBooks Transaction Date modal */}
                <QuickBooksDateModal
                    open={showDateModal}
                    onCancel={() => setShowDateModal(false)}
                    onApprove={(transactionDate?: Date) => handleQuickBooksDateSelected(transactionDate)}
                />
                <div className="mb-5">
                    {((isAccounting || isSuperUser) &&
                        <button className='bg-ptsblue-normal hover:bg-ptsblue-dark' onClick={downloadInvoiceCsv}>
                            Download All Districts
                        </button>
                    )}
                    {((isAccounting || isSuperUser) &&
                        <button className='mx-2 bg-ptsgreen-normal hover:bg-ptsgreen-dark'
                            onClick={() => handleSendInvoice()}
                        >
                            Sync/Send Invoices to QuickBooks
                        </button>
                    )}
                    <button className='bg-gray-400 hover:bg-gray-500'
                        onClick={() => handleInvoiceDetailsData()}
                    >
                        Refresh Status
                    </button>
                </div>
                <table className='w-full rounded-lg border-spacing-x-4 border-collapse'>
                    <thead className="font-bold align-bottom">
                        <tr className="text-left">
                            <th className="mx-2 pl-2">District Name</th>
                            <th className="mx-2">Invoice Number</th>
                            <th className="mx-2">Status</th>
                            <th className="mx-2">Print Detail</th>
                            <th className="mx-2 pr-2">Print Summary</th>
                        </tr>
                    </thead>
                    <tbody className="rounded-lg">
                        {exportedGroup?.map((eg, idx) => (
                            <tr key={`exportedInvoice_${idx}`}
                                id={`exported-invoice-district-${eg.districtId}`}
                                className="h-16 rounded-lg odd:bg-gray-100"
                            >
                                <td className="mx-2 pl-2">{eg.districtName}</td>
                                <td className="mx-2">{eg.invoiceNumber}</td>
                                <td className="mx-2">{eg.status}</td>
                                <td className="mx-2 pr-2">
                                    <span className='text-ptsblue-normal cursor-pointer hover:underline my-2'
                                        onClick={(e) => {
                                            navigateToSummaryReport(eg.districtId, eg.year, eg.month, eg.programId)
                                        }}>
                                        Print Summary
                                    </span>
                                </td>
                                <td className="mx-2 pr-2">
                                    <span className='text-ptsblue-normal cursor-pointer hover:underline my-2'
                                        onClick={(e) => navigateToDetailReport(eg.districtId, eg.year, eg.month, eg.programId)}>
                                        Print Detail
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Layout>
    );
};

export default InvoiceExportsDetail;